import GppGoodOutlined from '@mui/icons-material/GppGoodOutlined';
import { ReactElement } from 'react';

import { formatArchived } from '~/utils/date/date';
import { ICeArchivedExemption, ICeExemption } from '~/services/api/communityEngagement/types';

import ArchivedRow from '../ArchivedRow';
import ArchivedSection from '../ArchivedSection';
import ExemptionRow from '../ExemptionRow';
import RowActions from '../RowActions';
import ceStyles from '~/ui/pages/Clients/reusable/CommunityEngagement/CommunityEngagement.module.scss';

import styles from './ExemptionBanner.module.scss';

interface IExemptionBannerProps {
  exemptions: ICeExemption[];
  archivedExemptions: ICeArchivedExemption[];
  onEditExemption: (exemption: ICeExemption) => void;
  onArchiveExemption: (exemption: ICeExemption) => void;
  onRestoreExemption: (exemption: ICeArchivedExemption) => void;
  isRestoring: boolean;
}

const ExemptionBanner = ({
  exemptions,
  archivedExemptions,
  onEditExemption,
  onArchiveExemption,
  onRestoreExemption,
  isRestoring,
}: IExemptionBannerProps): ReactElement => (
  <section aria-label="Exemption" className={styles.exemption}>
    {exemptions.length > 0 && (
      <div className={styles.exemptBanner}>
        <GppGoodOutlined className={styles.exemptIcon} />
        Exempt this period
      </div>
    )}
    <div className={ceStyles.card}>
      {exemptions.map(exemption => (
        <ExemptionRow
          key={exemption.id}
          exemption={exemption}
          actions={
            <RowActions
              subject="exemption"
              onEdit={() => onEditExemption(exemption)}
              onArchive={exemption.isAutomatic ? undefined : () => onArchiveExemption(exemption)}
            />
          }
        />
      ))}
      {archivedExemptions.length > 0 && (
        <ArchivedSection>
          {archivedExemptions.map(archived =>
            archived.isAutomatic ? (
              <ExemptionRow key={archived.id} exemption={archived} isArchived />
            ) : (
              <ArchivedRow
                key={archived.id}
                title={archived.category.name}
                subtitle={formatArchived(archived.archivedOn)}
                onRestore={() => onRestoreExemption(archived)}
                isRestoreDisabled={isRestoring}
              />
            ),
          )}
        </ArchivedSection>
      )}
    </div>
  </section>
);

export default ExemptionBanner;
